import React from 'react';
import ArticleWarehouseRowProperties from "./ArticleWarehouseRowProperties";
import ViewMedium from "../../../ui_components/MediaView/ViewMedium";
import ArticleWarehouseRowMedium from "./ArticleWarehouseRowMedium";
import ViewLarge from "../../../ui_components/MediaView/ViewLarge";
import ViewSmall from "../../../ui_components/MediaView/ViewSmall";
import ArticleWarehouseRowSmall from "./ArticleWarehouseRowSmall";


const ArticleWarehouseRow: React.FC<ArticleWarehouseRowProperties> = ({
                                                      articleWarehouse,
                                                      onUpdate
                                                  }) => {
    return (
        <>
            <ViewSmall>
                <ArticleWarehouseRowSmall onUpdate={onUpdate} articleWarehouse={articleWarehouse}/>
            </ViewSmall>
            <ViewMedium>
                <ArticleWarehouseRowMedium onUpdate={onUpdate} articleWarehouse={articleWarehouse} />
            </ViewMedium>
            <ViewLarge>
                <ArticleWarehouseRowMedium onUpdate={onUpdate} articleWarehouse={articleWarehouse} />
            </ViewLarge>
        </>
    )
}

export default ArticleWarehouseRow;
